import { SettingsV2 } from '@dixa/messenger-api-payloads';
import { createAction } from '@reduxjs/toolkit';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';

import {
  MessengerKnowledgeBaseMode,
  MessengerKnowledgeBaseType,
  Translatable,
} from './messengerSettings.types';

const prefix = 'settings/messenger/knowledge';

export const messengerSettingsActions = {
  toggleElevioIntegration: createAction<void>(
    `${prefix}/toggleElevioIntegration`,
  ),

  toggleDixaKnowledgeIntegration: createAction<void>(
    `${prefix}/toggleDixaKnowledgeIntegration`,
  ),

  updateDisplayType: createAction<MessengerKnowledgeBaseMode>(
    `${prefix}/updateDisplayType`,
  ),

  changeSelectedLanguage: createAction<MessengerTranslatedLanguage>(
    `${prefix}/changeSelectedLanguage`,
  ),

  updateTranslatedString: createAction<{
    translatable: Translatable;
    language: MessengerTranslatedLanguage;
    value: string;
  }>(`${prefix}/updateTranslatedString`),

  changeKnowledgeBaseType: createAction<MessengerKnowledgeBaseType>(
    `${prefix}/changeKnowledgeBaseType`,
  ),

  setDixaKnowledgeHelpCenterId: createAction<string>(
    `${prefix}/setDixaKnowledgeHelpCenterId`,
  ),

  setElevioCompanyId: createAction<string>(`${prefix}/setElevioCompanyId`),

  initialize: createAction<SettingsV2.Settings>(`${prefix}/initialize`),

  reset: createAction<void>(`${prefix}/reset`),
};
